/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import {
  SideListProps,
  SideListDataItem,
} from 'app/components/Charts/sunburst/common/sidelist/data';
import {
  containercss,
  listheadercss,
  listitemcss,
  listitemcirclecss,
  gradientlinecss,
  listitemcopy,
} from 'app/components/Charts/sunburst/common/sidelist/styles';

export function SideList(props: SideListProps) {
  return (
    <div css={containercss} style={props.overflowList ? { width: '90%' } : {}}>
      {props.selected === '' && (
        <Typography variant="h5" color="textPrimary" css={listheadercss}>
          {props.title}
        </Typography>
      )}
      {/* @ts-ignore */}
      {props.data.name !== 'empty' && props.data.title !== 'empty' && (
        <div
          css={containercss}
          style={
            props.overflowList ? { maxHeight: 400, overflowY: 'auto' } : {}
          }
        >
          {props.selected !== '' && (
            <span
              css={gradientlinecss(
                props.data.children.map((item: any) => item.color)
              )}
            />
          )}
          {props.data.children.map((item: SideListDataItem) => (
            <div
              key={item.title}
              css={listitemcss(props.withLinks)}
              onClick={() =>
                props.handleClick && props.handleClick({ data: item })
              }
            >
              <div css={listitemcirclecss(item.color)} />
              <div css={listitemcopy()}>{item.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function BottomGridList(props: SideListProps) {
  return (
    <React.Fragment>
      <Box width="100%" height="24px" />
      {props.data.children.map((item: SideListDataItem) => (
        <Grid
          item
          sm={6}
          md={4}
          lg={3}
          key={item.title}
          css={listitemcss(props.withLinks)}
          onClick={() => props.handleClick && props.handleClick({ data: item })}
        >
          <div css={listitemcirclecss(item.color)} />
          <div css={listitemcopy()}>{item.title}</div>
        </Grid>
      ))}
    </React.Fragment>
  );
}
